import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useIsAdmin } from "@/hooks/useUserRole";

export function useSupportAgentVisibility() {
  const { isAdmin, isLoading: adminLoading } = useIsAdmin();

  const { data: featureFlag, isLoading: flagLoading } = useQuery({
    queryKey: ["feature-flag", "support_agent_enabled"],
    queryFn: async () => {
      const { data } = await supabase
        .from("platform_feature_flags")
        .select("*")
        .eq("feature_key", "support_agent_enabled")
        .single();
      return data;
    },
    staleTime: 30 * 1000,
  });

  return {
    showAgent: featureFlag?.is_enabled === true,
    isLoading: adminLoading || flagLoading,
    isAdmin,
  };
}
